import { contactFormOptions } from '@/components/react/form/forms/formOptions';
import { withForm } from '@/components/react/form/hooks/form';
import {
  COUNTRIES,
  PROVINCES,
  STATES,
} from '@/components/react/form/select-values';
import {
  ERROR_MESSAGES,
  INPUT_LABELS,
} from '@/components/react/form/translations';
import freeEmailDomains from 'free-email-domains/domains.json';
import { isValidPhoneNumber } from 'react-phone-number-input';

import companySizes from '@/components/react/form/select-values/companySize';
import industries from '@/components/react/form/select-values/industries';
import type { AstroLocale } from '@/schemas/components/shared/i18n';

export const ChineseFormFields = withForm({
  ...contactFormOptions,
  props: {
    language: 'zh' as AstroLocale,
    sortedCountries: COUNTRIES,
  },
  render: ({ form, language, sortedCountries }) => (
    <>
      <div className="flex flex-col gap-x-8 @sm:flex-row">
        <form.AppField
          name="Name"
          validators={{
            onChange: ({ value }) => {
              if (!value) return ERROR_MESSAGES.empty[language];
            },
          }}
        >
          {(field) => <field.TextInput label={INPUT_LABELS.name[language]} />}
        </form.AppField>
        <form.AppField
          name="job_title"
          validators={{
            onChange: ({ value }) => {
              if (!value) return ERROR_MESSAGES.empty[language];
            },
          }}
        >
          {(field) => (
            <field.TextInput label={INPUT_LABELS.jobTitle[language]} />
          )}
        </form.AppField>
      </div>
      <div className="flex flex-col gap-x-8 @sm:flex-row">
        <form.AppField
          name="company"
          validators={{
            onChange: ({ value }) => {
              if (!value) return ERROR_MESSAGES.empty[language];
            },
          }}
        >
          {(field) => (
            <field.TextInput label={INPUT_LABELS.companyName[language]} />
          )}
        </form.AppField>
        <form.AppField
          name="email"
          validators={{
            onChange: ({ value }) => {
              if (!value) return ERROR_MESSAGES.empty[language];

              const [username, domain] = value.split('@');

              if (!domain || username.length < 1) {
                return ERROR_MESSAGES.emailValid[language];
              }

              if (freeEmailDomains.includes(domain)) {
                return ERROR_MESSAGES.emailDomain[language];
              }
            },
          }}
        >
          {(field) => <field.TextInput label={INPUT_LABELS.email[language]} />}
        </form.AppField>
      </div>
      <div>
        <form.AppField
          name="phone"
          validators={{
            onChange: ({ value }) => {
              if (!value) return ERROR_MESSAGES.empty[language];

              if (!isValidPhoneNumber(value))
                return ERROR_MESSAGES.phone[language];
            },
          }}
        >
          {(field) => (
            <field.PhoneNumberInput
              label={INPUT_LABELS.phoneNumber[language]}
            />
          )}
        </form.AppField>
      </div>
      <div>
        <form.AppField
          name="industry"
          validators={{
            onChange: ({ value }) => {
              if (!value) return ERROR_MESSAGES.empty[language];
            },
          }}
        >
          {(field) => (
            <field.SelectDropdown
              items={industries}
              placeholder={INPUT_LABELS.industry[language]}
              language={language}
            />
          )}
        </form.AppField>
      </div>
      <div>
        <form.AppField
          name="Employee_Size"
          validators={{
            onChange: ({ value }) => {
              if (!value) return ERROR_MESSAGES.empty[language];
            },
          }}
        >
          {(field) => (
            <field.SelectDropdown
              items={companySizes}
              placeholder={INPUT_LABELS.companySize[language]}
              language={language}
            />
          )}
        </form.AppField>
      </div>
      <div>
        <form.AppField
          name="country"
          validators={{
            onChange: ({ value }) => {
              if (!value) return ERROR_MESSAGES.empty[language];
            },
          }}
        >
          {(field) => (
            <field.SelectDropdown
              items={sortedCountries}
              placeholder={INPUT_LABELS.country[language]}
              language={language}
            />
          )}
        </form.AppField>
        <form.Subscribe selector={({ values }) => values.country}>
          {(country) => {
            if (country === 'United States' || country === 'Canada') {
              const isUnitedStates = country === 'United States';
              const placeholder = isUnitedStates ? 'state' : 'province';
              const items = isUnitedStates ? STATES : PROVINCES;

              return (
                <div className="flex flex-col @sm:flex-row @sm:gap-8">
                  <form.AppField
                    name="state"
                    validators={{
                      onChange: ({ value }) => {
                        if (!value) return ERROR_MESSAGES.empty[language];
                      },
                    }}
                  >
                    {(field) => (
                      <field.SelectDropdown
                        items={items}
                        placeholder={INPUT_LABELS[placeholder][language]}
                        language={language}
                      />
                    )}
                  </form.AppField>
                </div>
              );
            }
          }}
        </form.Subscribe>
      </div>
      <div>
        <div>
          <form.AppField
            name="How_Did_You_Hear_About_Us"
            validators={{
              onChange: ({ value }) => {
                if (!value) return ERROR_MESSAGES.empty[language];
              },
            }}
          >
            {(field) => (
              <field.TextInput
                label={INPUT_LABELS.howDidYouHearAboutUs[language]}
              />
            )}
          </form.AppField>
        </div>
      </div>
    </>
  ),
});
